import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ca } from '@cian/analytics';
import { getCianAnalyticsObjectPage } from '../../utils/tracking';
import { PHONE_CODE_SENDER_TO_LABEL } from './constants';

/**
 * Показ блока авторизации
 */
export function trackAuthBlockShown(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'show'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Успешная авторизация
 */

export function trackAuthenticateSuccess(_ref) {
  var socialType = _ref.socialType,
    senderType = _ref.senderType,
    source = _ref.source;
  var label = senderType ? PHONE_CODE_SENDER_TO_LABEL[senderType] : socialType || '';
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Authorization',
    action: 'success',
    label: label
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик на кнопку "забыли пароль" при авторизации
 */
export function trackForgotPasswordClick(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'forgot_password_click',
    label: ''
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Успешная отправка формы "забыли пароль"
 */
export function trackForgotPasswordSubmitSuccess(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'get_password',
    label: ''
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик на кнопку "забыли пароль" при мердже
 */
export function trackForgotPasswordClickMerge(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'link_accounts_forgot_password',
    label: ''
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик по кнопке "хорошо" после запроса ссылки на восстановление
 */
export function trackResetPasswordGotItClick(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'reset_password_got_it'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик на кнопку "Войти по email или id" или "Войти по телефону"
 * @param {TAuthFlow} flow - flow type
 */
export function trackChangeLoginFlowTo(flow, source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: flow === 'email' ? 'login_email_ID' : 'login_phone'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Переход на шаг ввода пароля при пошаговой форме
 */
export function trackShowTwoStepPassword(element, source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'get_password_input',
    label: element
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Переход на шаг ввода пароля при пошаговой форме для нового пользователя
 */
export function trackShowTwoStepPasswordRegistration(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'make_new_password_input'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик на кнопку прололжить в форме пошаговой авторизации
 */
export function trackLoginResumeButtonClick(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'email_continue'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик по ссылке нужана помощь для флоу авторизации/регистрации по email/id
 */
export function trackLoginNeedHelp(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'reсovery_password_cant_confirm'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Клик на кнопку "Выбрать другой аккаунт"
 */
export function trackLoginAnotherWay(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'login_another_way'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}

/**
 * Переход на шаг ввода пароля после экрана выбора аккаунта
 */
export function trackShowConfirmAccount(source) {
  ca('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Authorization',
    action: 'Open',
    label: 'password_input_popup'
  }, source && {
    page: _objectSpread(_objectSpread({}, getCianAnalyticsObjectPage()), {}, {
      extra: {
        source: source
      }
    })
  }));
}